export default __webpack_public_path__ + "static/Artificial_Light_Indoor_2560kbps-9bf3a7ae66cfc5b6d92c0db2e7d51118.avif";